/**
 * ÜCRETSİZ PLAN EKRANI — paketi olmayan hesap giriş yaptığında uygulamanın YERİNE bu çıkar.
 * Sidebar, dashboard, asistan: hiçbiri yüklenmez.
 *
 * NOT: Bu ekran bir GÜVENLİK ÖNLEMİ DEĞİL, doğru mesajı gösterme katmanıdır.
 * Asıl engel sunucudadır (lib/plan-gate.ts → HTTP 402). Ön yüz kodu kurcalansa
 * bile API paketsiz hesaba tek bir iş yaptırmaz.
 */
import { useEffect, useState } from "react";
import { clearAuth } from "@/lib/auth";

const C = {
  bg: "#fafaf9", surface: "#ffffff", border: "#e7e7e4",
  text1: "#1d1d1b", text2: "#70706c", brand: "#e83e3c",
} as const;

export default function NoPlan() {
  const [ad, setAd] = useState("");

  useEffect(() => {
    // Bearer başlığını lib/auth.ts'teki fetch yaması otomatik ekler — elle vermeyiz.
    void fetch("/api/me/plan")
      .then((r) => (r.ok ? r.json() : null))
      .then((d: { name?: string; email?: string } | null) => setAd(d?.name || d?.email || ""))
      .catch(() => { /* ekran isimsiz de çizilir */ });
  }, []);

  return (
    <div style={{ minHeight: "100vh", background: C.bg, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
      <div style={{ width: "100%", maxWidth: 460, background: C.surface, border: `1px solid ${C.border}`, borderRadius: 16, padding: 36, boxShadow: "0 8px 30px rgba(0,0,0,0.06)", textAlign: "center" }}>
        <img src="/geolop-logo.svg" alt="Geolop" style={{ height: 32, marginBottom: 20 }} />

        <div style={{ display: "inline-block", fontSize: 12, fontWeight: 600, color: C.text2, background: "#f4f4f2", border: `1px solid ${C.border}`, borderRadius: 999, padding: "5px 14px", marginBottom: 18 }}>
          Ücretsiz Plan
        </div>

        <h1 style={{ fontSize: 20, fontWeight: 700, color: C.text1, margin: "0 0 12px", letterSpacing: "-0.02em" }}>
          {ad ? `Merhaba ${ad},` : "Hoş geldin,"}
        </h1>

        <p style={{ fontSize: 14, color: C.text2, lineHeight: 1.65, margin: "0 0 8px" }}>
          Hesabın açık ama <strong style={{ color: C.text1 }}>henüz bir paket tanımlanmadı</strong>.
          Ücretsiz planda site taraması, içerik üretimi ve analiz araçları kapalıdır.
        </p>
        <p style={{ fontSize: 14, color: C.text2, lineHeight: 1.65, margin: "0 0 26px" }}>
          Paketini açtırmak için bize yaz — kurulum ve ilk analizi biz yapıyoruz.
        </p>

        <a href="mailto:info@geolop.com?subject=Geolop%20paket%20talebi"
          style={{ display: "block", padding: "12px 0", borderRadius: 10, background: C.brand, color: "#fff", fontSize: 14, fontWeight: 600, textDecoration: "none" }}>
          info@geolop.com — Paket Talep Et
        </a>

        <button type="button"
          onClick={() => { clearAuth(); window.location.href = "/"; }}
          style={{ marginTop: 18, background: "none", border: "none", color: C.text2, fontSize: 12, textDecoration: "underline", cursor: "pointer" }}>
          Çıkış yap
        </button>
      </div>
    </div>
  );
}
